type MiddlewareArgs = {
  payload: {
    obj: Record<string, any>;
    [key: string]: any;
  };
  integrations?: Record<string, boolean>;
  next: (payload: MiddlewareArgs['payload']) => void;
};

const dedupIdMiddleware = ({ payload, next }: MiddlewareArgs) => {
  // To properly do deduplication on platforms like Facebook, we need to set the eventId of certain
  // events to match the eventId of event on the backend. Unfortunately, Analytics.js maps the messageId
  // as the eventId, but we cannot override the messageId itself from 'track' calls. This middleware
  // checks for the existence of an eventId and sets the messageId to match it.
  // See discussion here: https://github.com/segmentio/analytics-next/issues/370
  if (payload.obj.properties && payload.obj.properties.eventId) {
    payload.obj.messageId = payload.obj.properties.eventId;
  }
  next(payload);
};

export default dedupIdMiddleware;
